// src/components/cookies/CookieFloatingButton.jsx
import { useTranslation } from "react-i18next";
import CookieIcon from "@mui/icons-material/Cookie";
import PropTypes from "prop-types";

const CookieFloatingButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t("cookies.manage")}
      className="
        fixed bottom-5 left-5 z-[900]
        w-12 h-12 rounded-full
        flex items-center justify-center
        backdrop-blur-[30px]
        transition-all duration-300
        shadow-lg
        hover:scale-105 active:scale-95
      "
    >
      <CookieIcon className="text-[22px] text-[var(--tree-poppy)]" />
    </button>
  );
};

CookieFloatingButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CookieFloatingButton;
